<template>
    <div class="container-fluid mt-5">
        <!-- Row 2 -->
        <div class="row padding-15">
            <div class="col-12 form-input">
                <form>
                    <div class="form-group">
                        <div class="row">
                            <!-- floating input starts -->
                            <div class="col-sm-4">
                                <div class="form-group pr">
                                    <label style="font-weight:700;" for="first">Date Range
                                    </label>
                                    <small class="text-info">
                                        (Note: To choose one day, double click on specific
                                        date)</small>
                                    <flat-pickr class="form-control" style="background: #fff;opacity:1" placeholder="Start date Range" v-model="dateRange" :config="dateOptions"></flat-pickr>
                                </div>
                            </div>
    
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Thematic Area</label>
                                    <selectize id="select-state" v-model="thematicArea" :settings="selectSettings">
                                        <option v-for="(item,index) in thematicArr" :key="index" :value="item.id">
                                            {{item.name}}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Sub Programme</label>
                                    <selectize id="select-state" class="text-capitalize" v-model="subprogram" :searchable="true" :settings="selectSettings">
                                        <option v-for="(item, index) in subprogramsArray" :key="index" :value="item.id" :text="item.title" class="text-capitalize">
                                            {{ item.title }}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Project</label>
                                    <selectize id="select-state" class="text-capitalize" v-model="project" :searchable="true" :settings="selectSettings">
                                        <option v-for="(item, index) in projectsArray" :key="index" :value="item.id" :text="item.title" class="text-capitalize">
                                            {{ item.title }}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Advisor</label>
                                    <selectize id="select-state" class="text-capitalize" v-model="advisor" :searchable="true" :settings="selectSettings">
                                        <option v-for="(item, index) in advisorArray" :key="index" :value="item.id" :text="item.name" class="text-capitalize">
                                            {{ item.name }}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Program Officer</label>
                                    <selectize id="select-state" class="text-capitalize" v-model="officer" :searchable="true" :settings="selectSettings">
                                        <option v-for="(item, index) in officerArray" :key="index" :value="item.id" :text="item.name" class="text-capitalize">
                                            {{ item.name }}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Event Title
                                    </label>
                                    <input class="floating-input form-control" v-model="trainingTitle" type="text" placeholder="Event Title..." />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Donor</label>
                                    <selectize id="select-state" v-model="donerName" :searchable="true" :settings="selectSettings">
                                        <option v-for="(item, index) in donernameArr" :key="index" :value="item.id">
                                            {{ item.title }}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
    
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Department</label>
                                    <selectize id="select-state" v-model="department" :searchable="true" :settings="selectSettings">
                                        <option v-for="(item,index) in departmentArr" :key="index" :value="item.id">
                                            {{item.title}}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Type (Training / Workshop)</label>
                                    <selectize v-model="trainingType" :searchable="true" :settings="selectSettings">
                                        <option v-for="(tType,index) in trainingTypeArr" :key="index" :value="tType.id">
                                            {{tType.title}}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Event Topic</label>
                                    <input class="floating-input form-control" v-model="trainingTopic" type="text" placeholder="Event Topic..." />
                                </div>
                            </div>
                            <!-- <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Province</label>
                                    <selectize id="select-state" v-model="province" :searchable="true" :settings="selectSettings">
                                        <option v-for="(item,index) in provinceArr" :key="index" :value="item.id">
                                            {{item.title}}
                                        </option>
                                    </selectize>
                                </div>
                            </div> -->
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Location</label>
                                    <selectize id="select-state" v-model="district" :searchable="true" :settings="selectSettings">
                                        <option v-for="(item,index) in cityArr" :key="index" :value="item.id">
                                            {{item.title}}, {{item.province.title}},
                                            {{item.province.country.title}}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label style="font-weight:700;" for="first">Days</label>
                                    <input class="floating-input form-control" v-model="noOfDays" type="number" placeholder=" " />
                                </div>
                            </div>
                            <div class="col-md-4"></div>
                            <div class="col-md-4">
                                <div class="form-group reset-btn">
                                    <button class="btn btn-sm btn-info" @click="reportRest()">
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- Row 3 -->
        <div class="row">
            <div class="col-12 form-input">
                <b-button v-b-toggle.collapse-1 variant="primary" class="w-100 d-flex justify-content-between align-items-center toggle-button" @click="isCollapsed = !isCollapsed">
                    <span>Facilitators' information</span>
                    <!-- Dynamic up/down icon -->
                    <i class="material-icons">
                        {{ isCollapsed ? 'expand_more' : 'expand_less' }}
                    </i>
                </b-button>
    
                <b-collapse id="collapse-1" class="mt-2" @show="isCollapsed = false" @hide="isCollapsed = true">
                    <div class="p-3 bg-light">
                        <form>
                            <div class="form-group">
                                <div class="row">
                                    <!-- floating input starts -->
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Facilitator Name </label>
                                            <input class="floating-input form-control" v-model="trainerName" type="text" placeholder="Facilitator Name..." />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Facilitator Email </label>
                                            <input class="floating-input form-control" v-model="trainerEmail" type="text" placeholder="Trainer Email@..." />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Facilitator Department</label>
                                            <selectize id="select-state" v-model="trainerDepartment" :settings="selectSettings" :searchable="true">
                                                <option v-for="(item,index) in facultyDepartmentArr" :key="index" :value="item.id">
                                                    {{item.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Facilitator Designation</label>
                                            <selectize id="select-state" class="text-capitalize" v-model="trainerDesignation" :searchable="true" :settings="selectSettings">
                                                <option v-for="(item,index) in designationArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Facilitator Nationality</label>
                                            <selectize id="select-state" class="text-capitalize" v-model="trainerNationality" :searchable="true" :settings="selectSettings">
                                                <option v-for="(item,index) in nationalityArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.name}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Facilitator Qualification</label>
                                            <selectize id="select-state" class="text-capitalize" v-model="trainerQualification" :searchable="true" :settings="selectSettings">
                                                <option v-for="(item,index) in qualificationArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Facilitator Mobile Number</label>
                                            <input class="floating-input form-control" v-mask="'(9999)-9999999'" type="text" placeholder=" " v-model="trainerMobileNumber" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class=" ">
                                            <label style="font-weight:700;">Facilitator Gender</label>
                                        </div>
                                        <div style="padding-left: 5px;display: inline-flex;">
                                            <div style="margin: 7px 6px 2px 6px">
                                                <vs-radio v-model="trainerGender" vs-name="radios1" vs-value="male">Male</vs-radio>
                                            </div>
                                            <div style="margin: 7px 6px 2px 6px">
                                                <vs-radio v-model="trainerGender" vs-name="radios1" vs-value="female">Female</vs-radio>
                                            </div>
                                            <div style="margin: 7px 6px 2px 6px">
                                                <vs-radio v-model="trainerGender" vs-name="radios1" vs-value="rather not say">Rather not say</vs-radio>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group reset-btn">
                                            <button class="btn btn-sm btn-info" @click="trainerRest()">
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </b-collapse>
            </div>
        </div>
        <!-- Row 4 -->
        <div class="row mt-2">
            <div class="col-12 form-input">
                <b-button v-b-toggle.collapse-2 variant="primary" class="w-100 d-flex justify-content-between align-items-center toggle-button" @click="isTraineeShow = !isTraineeShow">
                    <span>Participans' information</span>
                    <!-- Dynamic up/down icon -->
                    <i class="material-icons">
                        {{ isTraineeShow ? 'expand_more' : 'expand_less' }}
                    </i>
                </b-button>
    
                <b-collapse id="collapse-2" class="mt-2" @show="isTraineeShow = false" @hide="isTraineeShow = true">
                    <div class="p-3 bg-light">
                        <form>
                            <div class="form-group">
                                <div class="row">
                                    <!-- floating input starts -->
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Participant Name </label>
                                            <input class="floating-input form-control" v-model="traineeName" type="text" placeholder="Participant Name..." />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Participant Phone Number</label>
                                            <input class="floating-input form-control" v-mask="'(9999)-9999999'" type="text" placeholder=" " v-model="traineePhoneNumber" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Participant Email Address</label>
                                            <input class="floating-input form-control" v-model="traineeEmail" type="text" placeholder="Email" />
                                        </div>
                                    </div>
    
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Participant Profession</label>
                                            <selectize id="select-state" class="text-capitalize" v-model="traineeProfession" :settings="selectSettings" :searchable="true">
                                                <option v-for="(item,index) in professionArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.name}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Participant Department / Section</label>
                                            <selectize id="select-state" class="text-capitalize" v-model="traineeDepartment" :searchable="true" :settings="selectSettings">
                                                <option v-for="(item,index) in traineeDepartmentArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Participant Designation</label>
                                            <selectize id="select-state" class="text-capitalize" v-model="traineeDesignation" :searchable="true" :settings="selectSettings">
                                                <option v-for="(item,index) in traineeDesignationArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Participant Sector</label>
                                            <selectize id="select-state" class="text-capitalize" v-model="traineeSector" :searchable="true" :settings="selectSettings">
                                                <option v-for="(item,index) in traineeSectorArr" :key="index" :value="item.id" class="text-capitalize">
                                                    {{item.name}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;" for="first">Participant Institution</label>
                                            <input class="floating-input form-control" v-model="traineeInstitution" type="text" placeholder="Institute Name" />
                                        </div>
                                    </div>
    
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label style="font-weight:700;">Participant Location</label>
                                            <selectize id="select-state" v-model="traineeDistrict" :settings="selectSettings" :searchable="true">
                                                <option v-for="(item,index) in cityArr" :key="index" :value="item.id">
                                                    {{item.title}}, {{item.province.title}},
                                                    {{item.province.country.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class=" ">
                                            <label style="font-weight:700;" for="first">Potential Trainer</label>
                                        </div>
                                        <div style="padding-left: 5px;">
                                             <select v-model="potentialTrainer" class="form-control">
                                               <option :value="null">-- Select --</option>
                                               <option :value="true">Yes</option>
                                               <option :value="false">No</option>
                                             </select>
                                           </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class=" ">
                                            <label style="font-weight:700;" for="first">Participant Gender</label>
                                        </div>
                                        <div style="padding-left: 5px;display: inline-flex;">
                                            <div style="margin: 7px 6px 2px 6px">
                                                <vs-radio v-model="traineeGender" vs-name="radios1" vs-value="male">Male</vs-radio>
                                            </div>
                                            <div style="margin: 7px 6px 2px 6px">
                                                <vs-radio v-model="traineeGender" vs-name="radios1" vs-value="female">Female</vs-radio>
                                            </div>
                                            <div style="margin: 7px 6px 2px 6px">
                                                <vs-radio v-model="traineeGender" vs-name="radios1" vs-value="rather not say">Rather not say</vs-radio>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group reset-btn">
                                            <button class="btn btn-sm btn-info" @click="traineeRest()">
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </b-collapse>
            </div>
        </div>
        <div class="row mt-2 pb-3">
            <div class="col-12 text-right">
                <button type="button" class="btn  btn-sm m-1 submit-btn" @click="submitStaticalForm">
                    Submit
                </button>
            </div>
        </div>
        <div class="row padding-15">
        <div class="col-lg-3 col-sm-6 lyout-item" v-for="(item, index) in cards2" :key="index">
            <div class="card">
                <div class="card-header" :style="{ background: item.gradient }">
                    <i class="material-icons color-ff icon-size">{{ item.icon }}</i>
                </div>
                <div class="card-content">
                    <p class="category">{{ item.category }}</p>
                    <h3 class="title">{{ item.currentCount }}</h3>
                </div>
            </div>
        </div>
    </div>
        <div class="row note-text-row">
            <div class="col-12">
                 <div class="note-text">Note: The generated report will not show the events which do not have facilitator and/or participant assigned.</div>
            </div>
        </div>
        <!-- Table 3 -->
        <div class="row">
            <template>
                <div class="container-fluid table pt-2">
                    <div class="row justify-content-between">
                        <div class="col-6">
                            <h2>Statistical Report</h2>
                        </div>
                        <!-- Print Button Positioned to the Right -->
                        <div class="col-6 text-right">
                            <i class="material-icons mr-4" style="cursor: pointer; font-size: 28px !important;" @click="modalOpen">filter_list</i>
                            <b-button variant="success" @click="downloadCSV" class="print-btn">
                                Download CSV
                            </b-button>
                        </div>
                    </div>
    
                    <!-- Modal for Column Selection -->
    
                    <div class="modal3" v-if="showModal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header">
                                    <h4 class="">Select Columns to Display</h4>
                                    <button type="button" class="close" @click="closeModal">
                                        &times;
                                    </button>
                                </div>
    
                                <!-- Modal body -->
                                <div class="modal-body">
                                    <div>
                                        <div class="row">
                                            <div class="form-check col-6 col-md-3" v-for="(col, index) in columns" :key="index">
                                                <input class="form-check-input styled-checkbox" type="checkbox" :id="'col-' + index" :value="col.key" v-model="col.visible" />
                                                <label class="form-check-label" :for="'col-' + index">
                                                    {{ col.label }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <!-- Table in a scrollable container -->
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th v-for="(col, index) in visibleColumns" :key="index">
                                        {{ col.label }}
                                    </th>
                                    <th>Facilitators</th>
                                    <th>Participants</th>
                                    <th>Pre Percentage</th>
                                    <th>Post Percentage</th>
                                    <th>Knowledge Change</th>
                                    <th>Potential Trainers</th>
                                    <th>Male Participants</th>
                                    <th>Female Participants</th>
                                    <th>Other Participants</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, index) in updatedTrainingsData" :key="row.id">
                                    <td>{{ index + 1 }}</td>
                                    <td v-for="col in visibleColumns" :key="col.key">
                                        <template v-if="col.key === 'startdate' || col.key === 'enddate'">
                                            {{ formatDate(row[col.key]) }}
                                        </template>
                                        <template v-else>
                                            {{ row[col.key] }}
                                        </template>
                                    </td>
                                    <td @click="openTrainerModal(row.id)" style="cursor: pointer;">
                                        {{ getTrainerCount(row.id) }}
                                    </td>
                                    <td @click="openTraineeModal(row.id)" style="cursor: pointer;">
                                        {{ getTraineeCount(row.id) }}
                                    </td>
                                    <td v-if="row.prePercentage != ''">{{row.prePercentage}}%</td>
                                    <td v-else></td>
                                    <td v-if="row.postPercentage != ''">
                                        {{row.postPercentage}}%
                                    </td>
                                    <td v-else></td>
                                    <td>
                                        {{ calculatePercentage(row) }}
                                    </td>
                                    <td @click="openPotentialModal(row.id)" style="cursor: pointer;">{{row.potentialCount}}</td>
                                    <td @click="openGenderModal(row.id, 'male')" style="cursor: pointer;">{{row.genderCount.male}}</td>
                                    <td @click="openGenderModal(row.id, 'female')" style="cursor: pointer;">{{row.genderCount.female}}</td>
                                    <td @click="openGenderModal(row.id, 'other')" style="cursor: pointer;">{{row.genderCount.other}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
    
                    <!-- Trainer Modal -->
                    <div class="modal4" v-if="showTrainerModal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header">
                                    <h4 class="">Facilitators List</h4>
                                    <button type="button" class="close" @click="closeTrainerModal">
                                        &times;
                                    </button>
                                </div>
    
                                <!-- Modal body -->
                                <div class="modal-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Gender</th>
                                                    <th>CNIC</th>
                                                    <th>Contact No</th>
                                                    <th>Department</th>
                                                    <th>Designation</th>
                                                    <th>Qualification</th>
                                                    <th>Email</th>
                                                    <th>Address</th>
                                                    <th>Nationality</th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(trainee, index) in currentTrainers" :key="index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ trainee.name || 'N/A' }}</td>
                                                    <td>{{ trainee.gender || 'N/A' }}</td>
                                                    <td>{{ trainee.cnic || 'N/A' }}</td>
                                                    <td>{{ trainee.mobile || 'N/A' }}</td>
                                                    <td>{{ trainee.department || 'N/A' }}</td>
                                                    <td>{{ trainee.designation || 'N/A' }}</td>
                                                    <td>{{ trainee.qualification || 'N/A' }}</td>
                                                    <td>{{ trainee.email || 'N/A' }}</td>
                                                    <td>{{ trainee.address || 'N/A' }}</td>
                                                    <td>{{ trainee.nationality || 'N/A' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style="text-align: right;">
                                        <b-button variant="success" @click="downloadTrainerCSV">Download CSV</b-button>
                                        <b-button variant="secondary" class="ml-2" @click="closeTrainerModal">Close</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <!-- Trainee Modal -->
                    <div class="modal4" v-if="showTraineeModal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header">
                                    <h4 class="">Participants List</h4>
                                    <button type="button" class="close" @click="closeTraineeModal">
                                        &times;
                                    </button>
                                </div>
    
                                <!-- Modal body -->
                                <div class="modal-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Gender</th>
                                                    <th>CNIC</th>
                                                    <th>Contact No</th>
                                                    <th>Department</th>
                                                    <th>Designation</th>
                                                    <th>Email</th>
                                                    <th>Profession</th>
                                                    <th>Institution</th>
                                                    <th>Potential Trainer</th>
                                                    <th>District</th>
                                                    <th>Province</th>
                                                    <th>Country</th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(trainee, index) in currentTrainees" :key="index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ trainee.name || 'N/A' }}</td>
                                                    <td>{{ trainee.gender || 'N/A' }}</td>
                                                    <td>{{ trainee.cnic || 'N/A' }}</td>
                                                    <td>{{ trainee.contactNo || trainee.mobile || 'N/A' }}</td>
                                                    <td>{{ trainee.department || 'N/A' }}</td>
                                                    <td>{{ trainee.designation || 'N/A' }}</td>
                                                    <td>{{ trainee.email || 'N/A' }}</td>
                                                    <td>{{ trainee.profession || 'N/A' }}</td>
                                                    <td>{{ trainee.institution || 'N/A' }}</td>
                                                    <td>{{ trainee.potentialTrainer ? 'Yes' : 'No' }}</td>
                                                    <td>{{ trainee.district || 'N/A' }}</td>
                                                    <td>{{ trainee.province || 'N/A' }}</td>
                                                    <td>{{ trainee.country || 'N/A' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style="text-align: right;">
                                        <b-button variant="success" @click="downloadTraineeCSV">Download CSV</b-button>
                                        <b-button variant="secondary" class="ml-2" @click="closeTraineeModal">Close</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <!--  Modal -->
                    <div class="modal4" v-if="showGenderModal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header">
                                    <h4 class="">Participants</h4>
                                    <button type="button" class="close" @click="closeGenderModal">
                                        &times;
                                    </button>
                                </div>
    
                                <!-- Modal body -->
                                <div class="modal-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Gender</th>
                                                    <th>CNIC</th>
                                                    <th>Contact No</th>
                                                    <th>Department</th>
                                                    <th>Designation</th>
                                                    <th>Email</th>
                                                    <th>Potential Trainer</th>
                                                    <th>Profession</th>
                                                    <th>Institution</th>
                                                    <th>District</th>
                                                    <th>Province</th>
                                                    <th>Country</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(trainee, index) in currentGender" :key="index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ trainee.name || 'N/A' }}</td>
                                                    <td>{{ trainee.gender || 'N/A' }}</td>
                                                    <td>{{ trainee.cnic || 'N/A' }}</td>
                                                    <td>{{ trainee.contactNo || trainee.mobile || 'N/A' }}</td>
                                                    <td>{{ trainee.department || 'N/A' }}</td>
                                                    <td>{{ trainee.designation || 'N/A' }}</td>
                                                    <td>{{ trainee.email || 'N/A' }}</td>
                                                    <td>{{ trainee.potentialTrainer ? 'Yes' : 'No' }}</td>
                                                    <td>{{ trainee.profession || 'N/A' }}</td>
                                                    <td>{{ trainee.institution || 'N/A' }}</td>
                                                    <td>{{ trainee.district || 'N/A' }}</td>
                                                    <td>{{ trainee.province || 'N/A' }}</td>
                                                    <td>{{ trainee.country || 'N/A' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style="text-align: right;">
                                        <!-- <b-button variant="success" @click="downloadTraineeCSV"
                          >Download CSV</b-button
                        > -->
                                        <b-button variant="secondary" class="ml-2" @click="closeGenderModal">Close</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Potential Trainers Modal -->
                    <div class="modal4" v-if="showPotentialModal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header">
                                    <h4 class="">Potential Trainers</h4>
                                    <button type="button" class="close" @click="closePotentialModal">
                                        &times;
                                    </button>
                                </div>

                                <!-- Modal body -->
                                <div class="modal-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Gender</th>
                                                    <th>CNIC</th>
                                                    <th>Contact No</th>
                                                    <th>Department</th>
                                                    <th>Designation</th>
                                                    <th>Email</th>
                                                    <th>Profession</th>
                                                    <th>Institution</th>
                                                    <th>District</th>
                                                    <th>Province</th>
                                                    <th>Country</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(trainee, index) in currentPotential" :key="index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ trainee.name || 'N/A' }}</td>
                                                    <td>{{ trainee.gender || 'N/A' }}</td>
                                                    <td>{{ trainee.cnic || 'N/A' }}</td>
                                                    <td>{{ trainee.contactNo || trainee.mobile || 'N/A' }}</td>
                                                    <td>{{ trainee.department || 'N/A' }}</td>
                                                    <td>{{ trainee.designation || 'N/A' }}</td>
                                                    <td>{{ trainee.email || 'N/A' }}</td>
                                                    <td>{{ trainee.profession || 'N/A' }}</td>
                                                    <td>{{ trainee.institution || 'N/A' }}</td>
                                                    <td>{{ trainee.district || 'N/A' }}</td>
                                                    <td>{{ trainee.province || 'N/A' }}</td>
                                                    <td>{{ trainee.country || 'N/A' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style="text-align: right;">
                                        <b-button variant="secondary" class="ml-2" @click="closePotentialModal">Close</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    
        <!--End  -->
    </div>
    </template>
    
    <script>
    import axios from "axios";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import Selectize from "vue2-selectize";
    import {
        downloadStaticReport,
        downloadTraineeList,
        downloadTrainerList
    } from '../../utils/DownloadStaticalReport'
    import {
        clearLocalStorage
    } from "../../utils/ClearCashe.js"
    
    export default {
        data() {
            return {
                userId: JSON.parse(localStorage.getItem("currentUser")).id,
                userRole: localStorage.getItem("isPermission"),
                BASE_PATH: process.env.VUE_APP_BASE_PATH,
                showTrainerModal: false,
                showTraineeModal: false,
                showGenderModal: false,
                showPotentialModal: false,
                currentTrainers: [],
                currentTrainees: [],
                currentGender: [],
                currentPotential: [],
                showModal: false,
                isCollapsed: true,
                isTraineeShow: true,
                selectSettings: {
                    maxItems: 5,
                    plugins: ["remove_button"],
                    delimiter: "|"
                },
                dashboardData: {},
                data2: [],
                cards2: [],
                dateRange: [],
                dateOptions: {
                    wrap: true,
                    weekNumbers: true,
                    mode: "range",
                    dateFormat: "d-m-Y"
                },
                officerArray: [],
                officer: [],
                donerSelected: [],
                thematicArr: [],
                thematicArea: [],
                subprogramsArray: [],
                subprogram: [],
                projectsArray: [],
                project: [],
                advisorArray: [],
                advisor: [],
                trainingTitle: "",
                donernameArr: [],
                donerName: [],
                departmentArr: [],
                facultyDepartmentArr: [],
                department: [],
                trainingTypeArr: [],
                trainingType: [],
                trainingTopic: "",
                cityArr: [],
                district: [],
                noOfDays: "",
                startDate: "",
                endDate: "",
                isDataEdit: 0,
                trainerName: "",
                trainerEmail: "",
                trainerDepartment: [],
                designationArr: [],
                trainerDesignation: [],
                nationalityArr: [],
                trainerNationality: [],
                qualificationArr: [],
                trainerQualification: [],
                trainerMobileNumber: "",
                trainerGender: "",
                traineeName: "",
                traineePhoneNumber: "",
                traineeEmail: "",
                traineeGender: "",
                professionArr: [],
                traineeProfession: [],
                traineeDepartmentArr: [],
                traineeDepartment: [],
                traineeDesignationArr: [],
                traineeDesignation: [],
                traineeSectorArr: [],
                traineeSector: [],
                traineeInstitution: "",
                traineeDistrict: [],
                responseData: [],
                trainingsData: [],
                updatedData: [],
                provinceArr: [],
                province: [],
                potentialTrainer:null,
                columns: [{
                        label: "Title",
                        key: "title",
                        visible: true
                    },
                    {
                        label: "Event Topic",
                        key: "trainingTopic",
                        visible: true
                    },
                    {
                        label: "Days",
                        key: "noofdays",
                        visible: true
                    },
    
                    {
                        label: "Thematic Area",
                        key: "thematic_id",
                        visible: true
                    },
                    {
                        label: "Donor",
                        key: "doner_id",
                        visible: true
                    },
                    {
                        label: "Sub Programme",
                        key: "subprogram_id",
                        visible: false
                    },
                    {
                        label: "Advisor",
                        key: "advisor_id",
                        visible: true
                    },
                    {
                        label: "Program Officer",
                        key: "programofficer_id",
                        visible: true
                    },
                    {
                        label: "Project",
                        key: "project_id",
                        visible: true
                    },
                    {
                        label: "Location",
                        key: "district_id",
                        visible: true
                    },
                    {
                        label: "Start Date",
                        key: "startdate",
                        visible: false
                    },
                    {
                        label: "End Date",
                        key: "enddate",
                        visible: false
                    },
                    {
                        label: "Venue",
                        key: "venue",
                        visible: false
                    },
                ],
            }
        },
        mounted() {
            axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    
            this.getThematicArea();
            this.getSubProgram();
            this.getProjects();
            this.getAdvisor();
            this.getOfficer();
            this.getDoner();
            this.getDepartment();
            this.getTrainingType();
            this.getLocation();
            this.getTrainerDesignation();
            this.getTrainerNationality();
            this.getTrainerQualification();
            this.getTraineeProfession();
            this.getTraineeDepartment();
            this.getTraineeDesignation();
            this.getTraineeSector();
            this.getFacultyDepartment();
            this.getProvince();
    
        },
        methods: {
            formatDate(dateStr) {
                if (!dateStr) return '';
                const [year, month, day] = dateStr.split('-');
                return `${day}-${month}-${year}`;
            },
            modalOpen() {
                this.showModal = true
            },
            closeModal() {
                this.showModal = false;
            },
            getThematicArea() {
                this.openLoading();
                let endpoint = "";
                     switch (this.userRole) {
                         case "admin":
                         case "comm_officer":
                         case "country_represent":
                             endpoint = "/show/thematicArea/get";
                             break;
                         case "advisor":
                             endpoint = `/show/thematicArea/get?user_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/show/thematicArea/get?po_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }

                 axios
                 .get(this.BASE_PATH + endpoint)
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            clearLocalStorage();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            clearLocalStorage();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.thematicArr = response.data;
                    });
            },
            getSubProgram() {
                this.openLoading();
                this.openLoading();
                let endpoint = "";
                     switch (this.userRole) {
                         case "admin":
                         case "comm_officer":
                         case "country_represent":
                             endpoint = "/subprograms/get";
                             break;
                         case "advisor":
                             endpoint = `/subprograms/get?user_id=${this.userId}`;
                             break;
                         case "program_officer":
                             endpoint = `/subprograms/get?po_id=${this.userId}`;
                             break;
                         default:
                             throw new Error("Invalid user role");
                         }

                 axios
                 .get(this.BASE_PATH + endpoint)
               
                    .then(response => {
                        this.closeLoading();
                        this.subprogramsArray = response.data;
                    });
            },
            getProjects() {
                this.openLoading();
    
                axios.get(process.env.VUE_APP_BASE_PATH + "/projects/get")
                    .then(response => {
                        this.closeLoading();
                        this.projectsArray = response.data;
                    });
            },
            getAdvisor() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/advisor/get")
                    .then(response => {
    
                        this.closeLoading();
                        this.advisorArray = response.data;
                    });
            },
            getOfficer() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/programofficer/get")
                    .then(response => {
                        this.closeLoading();
                        this.officerArray = response.data;
                    });
            },
            getDoner() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/donernames/get")
                    .then(response => {
    
                        this.closeLoading();
                        this.donernameArr = response.data;
                    });
            },
            getDepartment() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/departments/get")
                    .then(response => {
    
                        this.closeLoading();
                        this.departmentArr = response.data;
                    });
            },
            getFacultyDepartment() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/user/departments/get")
                    .then(response => {
                        this.closeLoading();
                        this.facultyDepartmentArr = response.data;
                    });
            },
            getTrainingType() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/trainingtype/get")
                    .then(response => {
    
                        this.closeLoading();
                        this.trainingTypeArr = response.data;
                    });
            },
            getLocation() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/districts/get")
                    .then(response => {
    
                        this.closeLoading();
                        this.cityArr = response.data;
                    });
            },
            getProvince() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/provinces/get")
                    .then(response => {
    
                        this.closeLoading();
                        this.provinceArr = response.data;
                    });
            },
            getTrainerDesignation() {
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/designations/get")
                    .then((response) => {
                        this.designationArr = response.data;
                    });
            },
            getTrainerNationality() {
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/nationalities/get")
                    .then(response => {
    
                        this.nationalityArr = response.data;
                    });
            },
            getTrainerQualification() {
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get")
                    .then(response => {
    
                        this.qualificationArr = response.data;
                    });
            },
            getTraineeProfession() {
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/professions/get")
                    .then(response => {
    
                        this.professionArr = response.data;
                    });
            },
            getTraineeDepartment() {
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/departments/get")
                    .then((response) => {
    
                        this.traineeDepartmentArr = response.data;
                    });
            },
            getTraineeDesignation() {
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all")
                    .then((response) => {
    
                        this.traineeDesignationArr = response.data;
                    });
            },
            getTraineeSector() {
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/sectors/get")
                    .then((response) => {
                        this.traineeSectorArr = response.data;
                    });
            },
            openLoading() {
                this.$vs.loading({
                    type: "material"
                });
            },
            closeLoading() {
                this.$vs.loading.close();
            },
    
            populateCards() {
                this.cards2 = [{
                        item: 1,
                        icon: 'assignment_ind',
                        category: 'Events(Trainings/Workshops/Sessions)',
                        value: this.responseData.trainingStats.trainingCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #9c27b0, #7b1fa2)'
                    },
                    {
                        item: 2,
                        icon: 'people',
                        category: 'Thematic Areas',
                        value: this.responseData.trainingStats.thematicCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #7e57c2, #5e35b1)'
                    },
                    {
                        item: 3,
                        icon: 'people_outline',
                        category: 'Donors',
                        value: this.responseData.trainingStats.donerCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #78909c, #546e7a)'
                    },
                    {
                        item: 4,
                        icon: 'assignment_ind',
                        category: 'Facilitators',
                        value: this.responseData?.trainingStats?.trainerCount ?? 0,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #ef5350, #e53935)'
                    },
                    {
                        item: 5,
                        icon: 'people',
                        category: 'Participants',
                        value: this.responseData?.trainingStats?.traineesCount ?? 0,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #29b6f6, #039be5)'
                    },
                    {
                        item: 6,
                        icon: 'people_outline',
                        category: 'Sub Programme',
                        value: this.responseData.trainingStats.subprogramCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #ffee58, #fbc02d)'
                    },
                    {
                        item: 7,
                        icon: 'check_circle_outline',
                        category: 'Projects',
                        value: this.responseData.trainingStats.projectCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #ff7043, #f4511e)'
                    },
                    {
                        item: 8,
                        icon: 'hourglass_empty',
                        category: 'Advisors',
                        value: this.responseData.trainingStats.advisorCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #66cdaa, #2e8b57)'
                    },
                    {
                        item: 9,
                        icon: 'assignment_returned',
                        category: 'Programme Officers',
                        value: this.responseData.trainingStats.programofficerCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #9292b7, #a4a4ce)'
                    },
                    {
                        item: 10,
                        icon: 'equalizer',
                        category: 'Departments',
                        value: this.responseData.trainingStats.departmentCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #ec407a, #d81b60)',
    
                    },
                    {
                        item: 11,
                        icon: 'date_range',
                        category: 'Location',
                        value: this.responseData.trainingStats.locationCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #66bb6a, #43a047)',
    
                    },
                    // {
                    //     item: 12,
                    //     icon: 'assessment',
                    //     category: 'Events',
                    //     value: this.responseData.trainingStats.trainingCount,
                    //     currentCount: 0,
                    //     gradient: 'linear-gradient(60deg, #ffa726, #fb8c00)',
    
                    // },
                    {
                        item: 12,
                        icon: 'question_answer',
                        category: 'ToTs.',
                        value: this.responseData.trainingStats.typetrainingCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(60deg, #26c6da, #00acc1)',
    
                    },
                    {
                        item: 13,
                        icon: 'assignment_ind',
                        category: 'Potential Trainer',
                        value: this.responseData.trainingStats.potentialTrainerCount,
                        currentCount: 0,
                        gradient: 'linear-gradient(62deg, #9c47b0, #7b5fa2)'
                    },
                ]
            },
            animateCounts() {
                this.data2.forEach(card => {
                    this.animateCount(card, card.value);
                });
                this.cards2.forEach(card => {
                    this.animateCount(card, card.value);
                });
    
            },
            animateCount(card, value) {
                let count = 0;
                const step = Math.ceil(value / 30);
                const interval = setInterval(() => {
                    count += step;
                    if (count >= value) {
                        card.currentCount = value;
                        clearInterval(interval);
                    } else {
                        card.currentCount = count;
                    }
                }, 50);
            },
            getNameFromArray(id, array) {
                if (!array || !Array.isArray(array)) {
                    return 'Unknown';
                }

                // Handle comma-separated IDs
                if (typeof id === 'string' && id.includes(',')) {
                    const ids = id.split(',').map(id => id.trim());
                    const names = ids.map(singleId => {
                        const item = array.find(element => element.id == singleId);
                        return item ? (item.title || item.name || 'Unknown') : 'Unknown';
                    });
                    return names.join(', ');
                }

                // Handle single ID
                const item = array.find(element => element.id == id);
                return item ? (item.title || item.name || 'Unknown') : 'Unknown';
            },
    
            submitStaticalForm() {
                this.openLoading()
                const FormData = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    trainingTitle: this.trainingTitle,
                    trainingTopic: this.trainingTopic,
                    thematicIds: this.thematicArea,
                    subprogramIds: this.subprogram,
                    projectIds: this.project,
                    donorIds: this.donerName,
                    advisorIds: this.advisor,
                    programOfficerIds: this.officer,
                    departmentIds: this.department,
                    typetrainingIds: this.trainingType,
                    locationIds: this.district,
                    noofdays: this.noOfDays,
                    trainerName: this.trainerName,
                    trainerEmail: this.trainerEmail,
                    trainerPhone: this.trainerMobileNumber,
                    trainerGender: this.trainerGender,
                    trainerQualificationIds: this.trainerQualification,
                    trainerDepartmentIds: this.trainerDepartment,
                    trainerDesignationIds: this.trainerDesignation,
                    traineeName: this.traineeName,
                    traineeContactNo: this.traineePhoneNumber,
                    traineeEmail: this.traineeEmail,
                    traineeInstitution: this.traineeInstitution,
                    traineeGender: this.traineeGender,
                    traineeProfessionIds: this.traineeProfession,
                    traineeDepartmentIds: this.traineeDepartment,
                    traineeDesignationIds: this.traineeDesignation,
                    traineeSectorIds: this.traineeSector,
                    traineeDistrictIds: this.traineeDistrict,
                    trainerNationalities: this.trainerNationality,
                    potentialTrainer: this.potentialTrainer,

                    // provinceIds: this.province,
                }
    
                const isEmpty = (value) => {
                    return (
                        value === null || // null values
                        value === undefined || // undefined values
                        (typeof value === 'string' && value.trim() === '') || // empty strings
                        (Array.isArray(value) && value.length === 0) || // empty arrays
                        (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) // empty objects
                    );
                };
    
                // Filter out empty fields and convert empty arrays to null
                const filteredFormData = Object.fromEntries(
                    Object.entries(FormData).map(([key, value]) => {
                        if (Array.isArray(value) && value.length === 0) {
                            return [key, null];
                        }
                        return [key, value];
                    }).filter(([key, value]) => !isEmpty(value))
                );
    
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/reporting/master-report", filteredFormData)
                    .then((response) => {
                        this.closeLoading()
                        this.responseData = response.data
                        this.trainingsData = response.data.trainings
                        setTimeout(() => {
                            this.populateCards();
                            this.animateCounts();
    
                        }, 500);
    
                    })
    
            },
    
            downloadCSV() {
                downloadStaticReport(this.updatedData)
            },
            downloadTraineeCSV() {
                downloadTraineeList(this.currentTrainees)
            },
            downloadTrainerCSV() {
                downloadTrainerList(this.currentTrainers)
            },
    
            getTraineeCount(trainingId) {
                return this.responseData?.trainees[trainingId]?.trainees?.length || 0;
            },
    
            // Method to calculate the number of trainers (assuming trainers data is present similarly to trainees)
            getTrainerCount(trainingId) {
                return this.responseData.trainers[trainingId]?.length || 0;
            },
    
            getPrePercentage(trainingId) {
                return this.responseData.trainees[trainingId]?.prePercentage || '';
            },
            getPostPercentage(trainingId) {
                return this.responseData.trainees[trainingId]?.postPercentage || '';
            },
            getGenderCount(trainingId) {
                return {
                    male: this.responseData.trainees[trainingId]?.genderCount?.male || 0,
                    female: this.responseData.trainees[trainingId]?.genderCount?.female || 0,
                    other: this.responseData.trainees[trainingId]?.genderCount?.other || 0,
                };
            },
            getPotentialCount(trainingId) {
                const trainees = this.responseData?.trainees?.[trainingId]?.trainees || [];
                return trainees.filter(t => t.potentialTrainer).length;
            },
            calculatePercentage(row) {
                const {
                    postPercentage,
                    prePercentage
                } = row;
                // Check for null, NaN, or zero to avoid division errors
                if (postPercentage == 0 || prePercentage == 0) {
                    return '';
                }
                const percentageChange = Math.round(
                    ((postPercentage - prePercentage) / prePercentage) * 100
                );
                return `${percentageChange}%`;
            },
            // Method to open the modal and set the current list of trainers/trainees
            openTrainerModal(trainingId) {
                if (this.responseData && this.responseData.trainers && this.responseData.trainers[trainingId]) {
                    this.currentTrainers = this.responseData.trainers[trainingId];
                    this.showTrainerModal = true;
                } else {
                    this.$toasted.global.errorMsg('No facilitator data available');
                }
            },
            openTraineeModal(trainingId) {
                if (this.responseData && this.responseData.trainees && this.responseData.trainees[trainingId] && this.responseData.trainees[trainingId].trainees) {
                    this.currentTrainees = this.responseData.trainees[trainingId].trainees;
                    this.showTraineeModal = true;
                } else {
                    this.$toasted.global.errorMsg('No participant data available');
                }
            },
            openGenderModal(trainingId, gender) {
                if (this.responseData && this.responseData.trainees && this.responseData.trainees[trainingId] && this.responseData.trainees[trainingId].trainees) {
                    const filteredTrainees = this.responseData.trainees[trainingId].trainees.filter(trainee => trainee.gender === gender);
                    if (filteredTrainees.length > 0) {
                        this.currentGender = filteredTrainees;
                        this.showGenderModal = true;
                    } else {
                        this.$toasted.global.errorMsg(`No ${gender} participants found`);
                    }
                } else {
                    this.$toasted.global.errorMsg('No participant data available');
                }
            },
            openPotentialModal(trainingId) {
                if (this.responseData && this.responseData.trainees && this.responseData.trainees[trainingId] && this.responseData.trainees[trainingId].trainees) {
                    const filtered = this.responseData.trainees[trainingId].trainees.filter(t => t.potentialTrainer);
                    if (filtered.length > 0) {
                        this.currentPotential = filtered;
                        this.showPotentialModal = true;
                    } else {
                        this.$toasted.global.errorMsg('No potential trainers found');
                    }
                } else {
                    this.$toasted.global.errorMsg('No participant data available');
                }
            },
            closeTrainerModal() {
                this.showTrainerModal = false
            },
            closeTraineeModal() {
                this.showTraineeModal = false
            },
            closeGenderModal() {
                this.showGenderModal = false
            },
            closePotentialModal() {
                this.showPotentialModal = false
            },
            traineeRest() {
                this.traineeName = "";
                this.traineePhoneNumber = "";
                this.traineeEmail = "";
                this.traineeGender = "";
                this.traineeProfession = [];
                this.traineeDepartment = [];
                this.traineeDesignation = [];
                this.traineeSector = [];
                this.traineeInstitution = "";
                this.traineeDistrict = [];
                // Clear trainee related data
                this.currentTrainees = [];
                this.showTraineeModal = false;
            },
            reportRest() {
                // Reset all form fields
                this.dateRange = [];
                this.officer = [];
                this.donerSelected = [];
                this.thematicArea = [];
                this.subprogram = [];
                this.project = [];
                this.advisor = [];
                this.trainingTitle = "";
                this.donerName = [];
                this.department = [];
                this.trainingType = [];
                this.trainingTopic = "";
                this.district = [];
                this.noOfDays = "";
                
                // Reset all report data
                this.responseData = {};
                this.trainingsData = [];
                this.updatedData = [];
                this.currentTrainers = [];
                this.currentTrainees = [];
                this.currentGender = [];
                this.currentPotential = [];
                this.cards2 = [];
                
                // Reset modals
                this.showTrainerModal = false;
                this.showTraineeModal = false;
                this.showGenderModal = false;
                this.showPotentialModal = false;
                
                // Reset dates
                this.startDate = "";
                this.endDate = "";
            },
            trainerRest() {
                this.trainerName = "";
                this.trainerEmail = "";
                this.trainerDepartment = [];
                this.trainerDesignation = [];
                this.trainerNationality = "";
                this.trainerQualification = [];
                this.trainerMobileNumber = "";
                this.trainerGender = "";
                // Clear trainer related data
                this.currentTrainers = [];
                this.showTrainerModal = false;
            },
        },
        watch: {
    
            dateRange(date) {
                let startDateParts = date.split("to")[0].trim().split("-");
                let endDateParts = date.split("to")[1].trim().split("-");
                this.startDate = `${startDateParts[2]}-${startDateParts[1]}-${startDateParts[0]}`;
                this.endDate = `${endDateParts[2]}-${endDateParts[1]}-${endDateParts[0]}`;
            },
            updatedTrainingsData(newValue) {
                this.updatedData = newValue; // Update the data property whenever the computed property changes
            }
    
        },
        components: {
            flatPickr,
            Selectize
        },
        computed: {
    
            updatedTrainingsData() {
                return this.trainingsData.map(training => {
                    return {
                        ...training,
                        advisor_id: this.getNameFromArray(training.advisor_id, this.advisorArray),
                        programofficer_id: this.getNameFromArray(training.programofficer_id, this.officerArray),
                        thematic_id: this.getNameFromArray(training.thematic_id, this.thematicArr),
                        doner_id: this.getNameFromArray(training.doner_id, this.donernameArr),
                        subprogram_id: this.getNameFromArray(training.subprogram_id, this.subprogramsArray),
                        project_id: this.getNameFromArray(training.project_id, this.projectsArray),
                        district_id: this.getNameFromArray(training.district_id, this.cityArr),
                        traineeCount: this.getTraineeCount(training.id),
                        trainerCount: this.getTrainerCount(training.id),
                        prePercentage: this.getPrePercentage(training.id),
                        postPercentage: this.getPostPercentage(training.id),
                        genderCount: this.getGenderCount(training.id),
                        potentialCount: this.getPotentialCount(training.id),
                    };
                });
    
            },
    
            visibleColumns() {
                return this.columns.filter(col => col.visible);
            },
        }
    
    };
    </script>
    
    <style scoped>
    .myNavbar {
        color: rgb(255, 255, 255);
    }
    
    .padding-15 {
        padding-right: 15px;
        padding-left: 15px;
    }
    
    .container-fluid {
        background-color: #eee;
    }
    
    .lyout-item {
        padding-right: 15px;
        padding-left: 15px;
    }
    
    .icon-size {
        font-size: 24px !important;
    }
    
    .card:hover {
        transform: scale(1.03) translateY(-5px);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    }
    
    .card {
        display: inline-block;
        position: relative;
        width: 100%;
        margin: 25px 0;
        overflow: unset;
        -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .14);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .14);
        border-radius: 3px;
        color: rgba(0, 0, 0, .87);
        background: #fff;
        transition: transform 0.9s ease, box-shadow 0.9s ease;
    }
    
    .card-header {
        float: left;
        text-align: center;
        box-shadow: 0 12px 20px -10px rgba(76, 175, 80, .28), 0 4px 20px 0 rgba(0, 0, 0, .12), 0 7px 8px -5px rgba(76, 175, 80, .2);
        margin: -20px 15px 0;
        border-radius: 3px;
        padding: 15px;
    }
    
    .card-content {
        text-align: right;
        padding-top: 10px;
        padding-right: 20px;
    }
    
    .category {
        color: #999;
    }
    
    .color-ff {
        color: #fff
    }
    
    .toggle-button {
        font-size: 1.2rem;
        padding: 8px;
        text-align: left;
        background: #06a6e0 !important
    }
    
    .toggle-button i {
        transition: transform 0.3s ease;
    }
    
    .b-collapse:not(.show)+.toggle-button i {
        transform: rotate(0deg);
    }
    
    .b-collapse.show+.toggle-button i {
        transform: rotate(180deg);
        /* Rotate the arrow when open */
    }
    
    .submit-btn {
        width: 140px;
        height: 40px;
        background: #06a6e0;
        font-size: 20px;
        color: aliceblue;
        font-weight: 600;
    }
    
    .submit-btn:hover {
        background: #1585ad;
        color: aliceblue;
    }
    
    /* Optional Styling */
    
    .container {
        margin-top: 20px;
    }
    
    .form-check {
        margin-bottom: 10px;
    }
    
    .table {
        background: #ffff;
        border-radius: 5px
    }
    
    .row {
        padding: 20px;
    }
    
    /* Custom checkbox styling */
    .styled-checkbox {
        margin-right: 8px;
        transform: scale(1.2);
        /* Enlarge the checkboxes */
    }
    
    /* Bootstrap helper classes to style the modal and form elements */
    .form-check {
        margin-bottom: 15px;
    }
    
    /* Custom styling to make the modal more attractive */
    .b-modal {
        border-radius: 10px;
    }
    
    .modal-title {
        font-weight: bold;
        text-align: center;
    }
    
    .b-button {
        background-color: #007bff;
        border-color: #007bff;
        color: #fff;
    }
    
    .b-button:hover {
        background-color: #0056b3;
    }
    
    .form-check-label {
        padding-top: 9px;
    }
    
    .table-scroll {
        overflow-x: auto;
    
    }
    
    .modal3 {
        position: fixed;
        z-index: 99;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.8);
    }
    
    .modal3 .modal-dialog {
        max-width: 800px;
        margin: 12% auto;
    }
    
    .modal4 .modal-dialog {
        max-width: 85%;
        /* margin: 12% auto; */
    }
    .modal-header {
        color: #ffff;
        background-Color: #00a6e4;
    }
    
    .modal-content {
        padding: 0px;
        border: 1px solid #888;
        width: 100%;
    }
    
    .modal3 .modal-body {
        padding-left: 50px;
    }
    
    .close {
        color: #ffff !important;
    }
    
    .close:hover {
        color: #e61212 !important;
    }
    
    .modal4 {
        position: fixed;
        z-index: 99;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.8);
    }
    
    .reset-btn {
        text-align: end;
        padding-top: 27px
    }
    
    .text-info {
        position: absolute;
        top: 5px;
        line-height: 1;
    }
    
    .pr {
        position: relative;
    }
    .note-text{
        font-size: 16px;
        color: red;
    }
    .note-text-row{
        padding-bottom: 0px;
    }
    @media (max-width: 768px) {}
    </style>
    